import { render } from "./RequestPageEditorPage.vue?vue&type=template&id=08f0dba6&ts=true"
import script from "./RequestPageEditorPage.vue?vue&type=script&lang=ts"
export * from "./RequestPageEditorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__